import React from "react";
import "./Experience.css";
import { ExperienceData } from "../../parseJson";
import useInView from "../../hooks/useInView";

function Experience() {
  const [ref, isVisible] = useInView(0.2);

  return (
    <div className="experience main-section container-fluid" id="experience">
      <div
        ref={ref}
        className={`container reveal-animation ${isVisible ? "visible" : ""}`}
      >
        <div className="row justify-content-center">
          <div className="col-12 text-align-center">
            <div className="heading-container">
              <p className="heading-subtitle">{ExperienceData.subtitle}</p>
              <h2 className="heading-title">{ExperienceData.title}</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            <div className="experience-timeline">
              {ExperienceData.items.map((item, index) => (
                <div 
                  className="experience-item" 
                  key={index}
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  <div className="experience-dot"></div>
                  <div className="experience-content">
                    <div className="experience-date">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-calendar"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      {item.date}
                    </div>
                    <h3 className="experience-role">{item.role}</h3>
                    <div className="experience-company">{item.company}</div>
                    <p className="experience-desc">{item.description}</p>
                    
                    {/* Decorative element background inside the card */}
                    <div className="experience-decorator">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experience;
